"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasourceQueryWrapperWithContext = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const renderQueryResult_1 = require("../renderQueryResult");
const ErrorMessageWidgets_1 = require("../widgets/ErrorMessageWidgets");
// React Hooks can't be used inside a component class, so this function uses Hooks
// functionality to check permissions.
function DatasourceQueryWrapperWithContext(props) {
    const apiRequests = (0, catalog_core_1.useApiRequests)();
    const [canSetDescription, setCanSetDescription] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        var _a;
        apiRequests
            .canUserSetFieldDescription({ datasourceVizportalId: (_a = props.vizportalUrlId) !== null && _a !== void 0 ? _a : '' })
            .then(r => setCanSetDescription(r))
            .catch(() => {
            return;
        });
    }, [apiRequests, props.vizportalUrlId]);
    return react_1.default.createElement(DatasourceQueryWrapper, Object.assign({}, props, { canSetDescription: canSetDescription }));
}
exports.DatasourceQueryWrapperWithContext = DatasourceQueryWrapperWithContext;
class DatasourceQueryWrapper extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderDatasourceData = (data) => {
            const datasource = data.publishedDatasources ? data.publishedDatasources[0] : null;
            if (datasource) {
                return this.props.children(datasource, this.props.canSetDescription);
            }
            else {
                return react_1.default.createElement(data_catalog_shared_1.CenteredMessage, { message: catalog_messages_1.Messages.ErrorItemNotFound() });
            }
        };
    }
    render() {
        return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.DatasourceDocument, variables: { vizportalUrlId: this.props.vizportalUrlId } }, result => (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
                renderLoading: () => react_1.default.createElement(data_catalog_shared_1.CenteredFadeInSpinner, null),
                renderData: this.renderDatasourceData,
                renderNoData: ErrorMessageWidgets_1.renderNoData,
                renderDataWithError: (0, ErrorMessageWidgets_1.createRenderDataWithErrorFunction)(this.renderDatasourceData),
                renderError: ErrorMessageWidgets_1.renderError,
            } }))));
    }
}
//# sourceMappingURL=DatasourceQueryWrapper.js.map